import { FC } from 'react';
import { BiEditAlt } from 'react-icons/bi';
import { BsTrash } from 'react-icons/bs';
import { DAV_MAIN_DOMAIN, TourProps } from '../../../../constants';

interface TourCardProps {
  tour: TourProps;
  onEditHandler: () => void;
  onDeleteHandler: () => void;
}

const TourCard: FC<TourCardProps> = ({ tour, onEditHandler, onDeleteHandler }) => {
  const { name, slug, imageCover } = tour;
  return (
    <div className='flex gap-2 bg-white items-start rounded-lg shadow-sm hover:shadow-md p-2'>
      <div className='w-[64px] h-[64px] rounded-md bg-primary min-w-[64px]'>
        <img src={imageCover} alt='tour' className='w-full h-full  rounded-md' />
      </div>
      <div className='flex justify-between flex-1'>
        <div className='line-clamp-442 text-sm overflow-hidden'>
          <a href={`${DAV_MAIN_DOMAIN}/tours/${slug}`} rel='noreferrer' target='_blank'>
            {name}
          </a>
        </div>
        <div className='flex justify-between items-center '>
          <div
            className='hover:bg-black/5 flex justify-center items-center  rounded-full h-10 w-10 -mr-2'
            onClick={onEditHandler}
          >
            <BiEditAlt className='text-xl text-primary cursor-pointer' title='Edit' />
          </div>
          <div
            className='hover:bg-black/5 flex justify-center items-center  rounded-full h-10 w-10'
            onClick={onDeleteHandler}
          >
            <BsTrash className='text-xl text-red-500 cursor-pointer' title='Delete' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourCard;
